import { Accordion as AccordionPrimitive } from '@base-ui/react/accordion'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

function Accordion({ className, ...props }: AccordionPrimitive.Root.Props) {
    return (
        <AccordionPrimitive.Root
            data-slot='accordion'
            className={cn('flex w-full flex-col', className)}
            {...props}
        />
    )
}

function AccordionItem({ className, ...props }: AccordionPrimitive.Item.Props) {
    return (
        <AccordionPrimitive.Item
            data-slot='accordion-item'
            className={cn('border-b border-border', className)}
            {...props}
        />
    )
}

function AccordionTrigger({
    className,
    children,
    ...props
}: AccordionPrimitive.Trigger.Props) {
    return (
        <AccordionPrimitive.Header className='flex'>
            <AccordionPrimitive.Trigger
                data-slot='accordion-trigger'
                className={cn(
                    'group/accordion-trigger relative flex flex-1 cursor-pointer items-start justify-between gap-6 rounded-lg py-5 text-left font-medium transition-colors outline-none hover:text-primary focus-visible:ring-3 focus-visible:ring-ring/40 aria-disabled:pointer-events-none aria-disabled:opacity-50',
                    className
                )}
                {...props}
            >
                {children}

                <span className='mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors group-hover/accordion-trigger:border-primary/40 group-hover/accordion-trigger:text-primary'>
                    <ChevronDown className='size-4 transition-transform duration-200 group-aria-expanded/accordion-trigger:rotate-180' />
                </span>
            </AccordionPrimitive.Trigger>
        </AccordionPrimitive.Header>
    )
}

function AccordionContent({
    className,
    children,
    ...props
}: AccordionPrimitive.Panel.Props) {
    return (
        <AccordionPrimitive.Panel
            data-slot='accordion-content'
            className='h-(--accordion-panel-height) overflow-hidden transition-[height] duration-200 ease-out data-ending-style:h-0 data-starting-style:h-0 motion-reduce:transition-none'
            {...props}
        >
            <div className={cn('pb-6 pr-12', className)}>
                {children}
            </div>
        </AccordionPrimitive.Panel>
    )
}

export {
    Accordion,
    AccordionItem,
    AccordionTrigger,
    AccordionContent
}
